import { Component, OnInit, Output, EventEmitter } from '@angular/core';
import { Recette } from '../../../models/recette.model';
import { RecetteService } from '../../../services/recette.service';

@Component({
  selector: 'ngx-app-recette-list',
  templateUrl: './recette-list.component.html',
  styleUrls: ['./recette-list.component.scss'],
})
export class RecetteListComponent implements OnInit {
  recettes: Recette[];
  constructor(private recetteService: RecetteService) { 
    this.recetteService.get_recettes().subscribe((res: Recette[]) => {
      this.recettes = res;
  });
  }

  ngOnInit() {
  }
}
